import { render, staticRenderFns } from "./FornecedorSidebarImportacao.vue?vue&type=template&id=e9a0f164"
import script from "./FornecedorSidebarImportacao.vue?vue&type=script&lang=js"
export * from "./FornecedorSidebarImportacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports